(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["minutedrone-classe-ue"] && !Shopify.designMode) return;
  try {
    // UX t148 : comportement de l'infobulle de classe. Le contenu est rendu par Liquid. Écoute sur document : le thème peut remplacer le bloc au changement de variante.
  (() => {
    const ouvrir = (li, v) => {
      li.classList.toggle('est-ouvert', v);
      li.querySelector('.md-classe-info__declencheur').setAttribute('aria-expanded', String(v));
    };
    document.addEventListener('click', e => {
      const btn = e.target.closest?.('.md-classe-info__declencheur'); if (!btn) return;
      const li = btn.closest('.md-classe-info');
      // À la souris, la bulle est déjà ouverte par le survol : un clic ne la referme pas
      ouvrir(li, e.pointerType === 'mouse' || !li.classList.contains('est-ouvert'));
    });
    // Survol à la souris seulement : au toucher, un survol simulé précède le clic et refermerait la bulle
    document.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && e.target.matches?.('.md-classe-info')) ouvrir(e.target, true); }, true);
    document.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && e.target.matches?.('.md-classe-info')) ouvrir(e.target, false); }, true);
    document.addEventListener('focusout', e => {
      const li = e.target.closest?.('.md-classe-info');
      if (li && e.relatedTarget && !li.contains(e.relatedTarget)) ouvrir(li, false);
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      const li = e.target.closest?.('.md-classe-info'); if (!li) return;
      ouvrir(li, false); li.querySelector('.md-classe-info__declencheur').focus();
    });
    // t872 : la classe suit la variante choisie, reprise du HTML que le thème vient de recevoir
    document.addEventListener('variant:update', e => {
      const actuel = document.querySelector('.product-details .md-classe-ue');
      const nouveau = e.detail?.data?.html?.querySelector('.product-details .md-classe-ue');
      if (actuel && nouveau) actuel.replaceWith(nouveau);
    });
    // Toucher : un appui ailleurs referme la bulle
    document.addEventListener('pointerdown', e => {
      document.querySelectorAll('.md-classe-info.est-ouvert').forEach(li => { if (!li.contains(e.target)) ouvrir(li, false); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
